import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class GetdatafirebaseService {

  constructor(private firebase: AngularFireDatabase) { }

  getYear() {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/master/productionYear")
        .query
        .once("value")
        .then((snapshots) => {
          let year: any[] = [];
          snapshots.forEach((snapshot) => {
            year.push({
              key: snapshot.key, ...snapshot.val(),
            });
          });
          res(year);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

  //  ข้อมูลนักส่งเสริมทั้งหมด
  getSupportProfile() {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/supporterprofile")
        .query
        .once("value")
        .then((snapshots) => {
          let suplist: any[] = [];
          snapshots.forEach((snapshots) => {
            let rec = {
              key: snapshots.key, ...snapshots.val()
            }
            suplist.push(rec)
          });

          res(suplist);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

  //  ข้อมูลนักส่งเสริม - ชาวไร่
  async getSVProfile(role1: number, role2: number) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/profile")
        .query.orderByChild("mrole")
        .startAt(role1).endAt(role2)
        .once('value')
        .then((snapshots) => {
          let suplist: any[] = [];
          snapshots.forEach((snapshots) => {
            let rec = {
              key: snapshots.key, ...snapshots.val()
            }
            suplist.push(rec)
          });
          res(suplist);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

  async getFmProfile(code: string) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/profile")
        .query.orderByChild("code")
        .equalTo(code)
        .once("value")
        .then((snapshots) => {
          let suplist: any[] = [];
          snapshots.forEach((snapshots) => {
            let rec = {
              key: snapshots.key, ...snapshots.val()
            }
            suplist.push(rec)
          });
          res(suplist);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

  //  ข้อมูลนักส่งเสริม 1 คน
  getOnesupporter(code: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/supporterprofile/")
        .query
        .once("value")
        .then((snapshots) => {
          let onesup: any[] = [];
          snapshots.forEach((snapshots) => {
            let rec = {
              key: snapshots.key, ...snapshots.val()
            }
            if ((rec.code) === code) {
              onesup.push(rec)
            }
          });
          res(onesup);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

  //  ข้อมูลโซน
  getZonedata() {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/master/zone")
        .query
        .once("value")
        .then((snapshots) => {
          let zone: any;
          snapshots.forEach((snapshots) => {
            let lzone = {
              key: snapshots.key, ...snapshots.val()
            }
            zone.push(lzone)
            console.log(zone);
          });

          res(zone);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

  //  ข้อมูลแปลงของชาวไร่ 1 คน
  getPlantnobyfmcode(code: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/runLandno/")
        .query
        .once('value')
        .then((snapshots) => {
          let onefmdata: any[] = [];
          snapshots.forEach((snapshot) => {
            let rec = {
              key: snapshot.key, ...snapshot.val(),
            }
            if (rec.code == code) {
              onefmdata.push(rec)
            }
          });
          res(onefmdata);
        }).catch((e) => {
          rej(e);
        });

    });
  }

  // ตรวจสอบหมายเลขแปลงในโซน  
  Checkplantnobyzone(glandno: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("plant")
        .query
        .once('value')
        .then((snapshots) => {
          let plantdata: any[] = [];
          snapshots.forEach((snapshot) => {
            let rec = {
              key: snapshot.key, ...snapshot.val(),
            }
            if (rec.landno == glandno) {
              plantdata.push(rec)
            }
          });
          console.log(plantdata);
          res(plantdata);
        }).catch((e) => {
          rej(e);
        });

    });
  }

  getmapbykey(year = '', key = '') {
    return new Promise((res, rej) => {
      let maps: any = [];
      this.firebase
        .list(`inst1/tx/${year}/areas`)
        .query.orderByKey()
        .equalTo(key)
        .once("value")
        .then(function (snapshot) {
          snapshot.forEach(function (childS) {
            let rec = {
              key: childS.key, ...childS.val(),
            }
            maps.push(rec);
          });
          //console.log('rec : ', maps.length);
          res(maps)
        }).catch((e) => {
          rej(e)
        })
    })
  }

}
